{
    "ConsidermovedtounresolvedasoverflowedLabel": "Beschouw oproepen die naar onopgeloste apparaten zijn verplaatst als overlopend:",
    "StatisticCalculations_SectionHeader": "Statistische berekeningen",
    "StatisticCalculations_SectionPara": "U kunt kiezen of oproepen worden beschouwd als overstroomd of verlaten wanneer de toepassing opzettelijk",
    "NAME": "StatisticCalculations"
}